import React from "react"
import { BsTwitter, BsLinkedin, BsFillTelephoneFill } from "react-icons/bs"
import { FaFacebookF } from "react-icons/fa"
import { SiGmail } from "react-icons/si"

const socialIcons = [
    {
        id: 1,
        title: "Facebook",
        link: "https://www.facebook.com/",
        icon: <FaFacebookF/>
    },
    {
        id: 2,
        title: "Twitter",
        link: "https://twitter.com/",
        icon: <BsTwitter/>
    },
    {
        id: 3,
        title: "LinkedIn",
        link: "https://uk.linkedin.com/",
        icon: <BsLinkedin/>
    },
    {
        id: 4,
        title: "Gmail",
        link: "autoinsure@gmail.com",
        icon: <SiGmail/>
    },
    {
        id: 5,
        title: "Phone",
        link: "tel:02079998999",
        icon: <BsFillTelephoneFill/>
    }
]

export default socialIcons;